import {neverland as $, render, html, useState, useEffect} from 'neverland';

function isInteger(value) {
	return /^\d+$/.test(value);
}

const DateField = $(function(f, fields, doc, updateDoc, isViewMode = false) {
	
	function updateField(ev) {

		// Convert value to number if an integer.
		let newVal = ev.target.value;

		updateDoc(f, newVal);
	}

	return html`
		<input
			class="field-${f} ${isViewMode ? 'disabled' : ''}"
			type="date"
			value="${doc.curr[f]}"
			?disabled="${isViewMode}"
			oninput="${isViewMode ? null : updateField}"></input>
		<label>${fields[f].title}</label>
	`;

});

export default DateField;